type SwiperElementType = HTMLElement & {initialize: () => void};

// Standard Klasse fuer alle Redesign Swiper (Swiper Element (WebComponent))
class SwiperElement {
  // Basic params
  private static paramsBasic = {
    spaceBetween: 16,
    slidesOffsetBefore: 16,
    slidesOffsetAfter: 16,
    simulateTouch: true,
    navigation: true,
    mousewheel: {forceToAxis: true},
  };

  public static run(swiperSection: HTMLElement, params: Record<string | number, any>) {
    const swiperElement = swiperSection.querySelector<SwiperElementType>("swiper-container");
    if (!swiperElement) {
      return;
    }

    const slides = swiperElement.querySelectorAll<HTMLElement>("swiper-slide");
    if (!slides.length) {
      return;
    }

    Object.assign(swiperElement, SwiperElement.paramsBasic, params);
    swiperElement.initialize();
  }
}

export default SwiperElement;
